import requestHelper from '@/utils/requestHelper'

/**
 * @param  login
 */

/**
 * 登录
 * @param data
 */
export async function login(data: { account: string; password: string }) {
  return requestHelper.post('v4/demand/user/login', data)
}

/**
 * 手机验证码登录登录
 * @param data
 */
export async function userCaptchaLogin(data: { account: string; captcha: string }) {
  return requestHelper.post('v4/demand/user/captcha/login', data)
}

/**
 * 退出登录
 * @param data
 */
export async function loginOut(data: Record<string, any>) {
  return requestHelper.post('v4/demand/user/logout', data)
}

/**
 * @param  register
 */

/**
 * 获取用户信息
 */
export async function getUserEnterApplyInfo() {
  return requestHelper.post('v4/demand/user/info')
}

/**
 * 发送邮箱验证码
 * @param data
 */
export async function sendEmailVerifyCode(data: any) {
  return requestHelper.post('/v4/cmp/user/verifyCode/send/email', data)
}

/**
 * 注册
 * @param data
 */
export async function userRegister(data: { captcha: string; password: string; account: string }) {
  return requestHelper.post('/v4/demand/user/register', data)
}

/**
 * @param  forgot
 */

/**
 * 获取resetCode
 * @param data
 */
export async function validateAccount(data: {
  accountType?: string
  account?: string
  code: string
}) {
  return requestHelper.post('v4/demand/user/validate/account', data)
}

/**
 * 重置密码
 * @param data
 */
export async function resetPassword(data: { password: string; resetCode: string }) {
  return requestHelper.post('v4/demand/user/reset/password', data)
}
